module.exports = __webpack_public_path__ + "img/p70-banner.b8a22c11.png";